import axios from "axios";
var upload = function (url, file, onUploadProgress) {
    var formData = new FormData();
    formData.append("file", file);
    var http = axios.create({
        baseURL: url,
        headers: {},
    });
    return http.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress: onUploadProgress,
    });
};
export default {
    upload: upload,
};
